import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
export const useVideoSize = () => {
  const $ = _c(5);
  const [maxWidth, setMaxWidth] = useState("container.lg");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => setMaxWidth("container.md");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const setSmall = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setMaxWidth("container.lg");
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const setMedium = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setMaxWidth("container.xl");
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const setLarge = t2;
  let t3;
  if ($[3] !== maxWidth) {
    t3 = {
      maxWidth,
      setSmall,
      setMedium,
      setLarge
    };
    $[3] = maxWidth;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};